module.exports = __webpack_public_path__ + "img/close-icon-red.041b4d72.svg";